import imageSrc from 'img/empty-folder/archive-viewer.png';
import React from 'react';

import styles from './EmptyFolder.css';

export const EmptyFolder = () => (
    <div className={styles.emptyFolder}>
        <img src={imageSrc} alt="Пустая папка"/>
        <div className={styles.emptyFolderTitle}>Пустая папка</div>
        <div className={styles.emptyFolderSubtitle}>В папке еще ничего нет</div>
    </div>
);
